import { Bar } from "react-chartjs-2";
import colorPalette from "../../../Palette";
import { useEffect, useState } from "react";
import { border } from "@mui/system";

const TrendReportChartOEE = (props) => {

    const [labels, setLabels] = useState([])
    const [barDataset, setBarDataset] = useState([])
    const [lineDataset, setLineDataset] = useState([])

    useEffect(() => {
        const newLabels = []
        const newBarDataset = []
        const newLineDataset = []
        props.granular_efficiency_range_list.forEach((item) => {
            newLabels.push(item.granularity_range_display)
            newBarDataset.push(item.efficiency)
            newLineDataset.push(item.previous_granularity_efficiency_percent_average)
        })
        setLabels(newLabels)
        setBarDataset(newBarDataset)
        setLineDataset(newLineDataset)
    }, [props])

    // useEffect(() => {
    //     const newLabels = []
    //     const newBarDataset = []
    //     const newLineDataset = []
    //     props.granular_efficiency_range_list.forEach((item) => {
    //         console.log(item);
            
    //         newLabels.push(item.granularity_range_display)
    //         newBarDataset.push(item.efficiency)
    //         newLineDataset.push(item.previous_granularity_efficiency_percent_average)
    //     })
    //     setLabels(newLabels)
    //     setBarDataset(newBarDataset)
    //     setLineDataset(newLineDataset)
    // }, [])


    return (
        <div style={{ width: "95%", paddingLeft: "12px", height: "80%", paddingTop: "0px", display: "flex", justifyContent: "center", position: "relative" }}>
            <Bar 
                data={
                    {
                        labels: labels,
                        datasets: [
                            {
                                data: barDataset,
                                label: "Efficiency",
                                backgroundColor: colorPalette.success[100],
                                borderWidth: 0,
                                borderRadius: {
                                    topLeft: 4,
                                    topRight: 4
                                },
                                order: 2,
                            },
                            {
                                data: lineDataset,
                                label: "Previous Efficiency",
                                // backgroundColor: "#0A71CE",
                                borderColor: "#0A71CE",
                                borderWidth: 2,
                                type: "line",
                                pointRadius: 0,
                                order: 1,
                            },
                        ]
                    }
                }
                options={{
                    resizeDelay: 200,
                    onClick: (evt, element) => props.onLostTimeBarClick(data.slice((page - 1) * perPages, page * perPages)[element[0].index]),
                    onHover: (event, chartElement) => {
                        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
                    },
                    interaction: {
                        intersect: false,
                        mode: "index",
                        includeInvisible: true,
                    },
                    maintainAspectRatio: false,
                    scales : {
                        x: {
                            grid: {
                                display: false
                            },
                            ticks: {
                                autoSkip: false,
                                maxRotation: 90,
                                // minRotation: 90
                            }
                        },
                        y: {
                            // suggestedMax: getMaxValue(xAxisData.slice((page - 1) * perPages, page * perPages)),
                            title: {
                                display: true,
                                text: "% of Total",
                                padding: {
                                    bottom: 24        
                                }
                            },
                            grid: {
                                offset: true,
                                color: "#E2E4E9"
                            },
                            border: {
                                dash: [4, 5]
                            },
                            ticks: {
                                callback: function(value, index, values) {
                                    if (values.length > 6) {
                                        if (index % 2 !== 0) {
                                            return null;
                                        }
                                        else {
                                            return value + "%";
                                        }
                                    }
                                    else {
                                        return value + "%";
                                    }
                                }
                            },
                        }
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        datalabels: {
                            anchor: 'end',
                            align: 'top',
                            clamp: true,
                            // formatter: (value) => `${value}%`,
                            font: {
                            weight: 'bold',
                            size: `${20 / 19.2 * window.innerWidth / 100}px`
                            },
                            color: "#000"
                        },
                        tooltip: {
                            yAlign: "top",
                            xAlign: "center",
                            position: "nearest",
                            backgroundColor: "#FFF",
                            multiKeyBackground: "#fff",
                            titleColor: "#111827",
                            titleFont: {
                                weight: 'bold',
                                size: "14px",
                            },
                            bodyColor: "#666666",
                            bodyFont: {
                                weight: 'normal',
                                // size: "14px",
                            },
                            boxWidth: 4,
                            boxPadding: 4,
                            borderColor: "rgba(122, 122, 122, 0.2)",
                            borderWidth: 1,
                            callbacks: {
                                // title: function(context) {
                                //     console.log(1, context);
                                    
                                //     // return `${props.type}: ${context[0].label.replaceAll(",", "")}`;
                                // },
                                // beforeTitle: function(context) {
                                //     console.log(2, context);
                                //     // if (props.type === "Reason") {
                                //     //     return data.slice((page - 1) * perPages, page * perPages)[context[0].dataIndex].category ? `Category: ${data.slice((page - 1) * perPages, page * perPages)[context[0].dataIndex].category}` : "Category: No category";
                                //     // }
                                //     // else {
                                //     //     return null
                                //     // }
                                    
                                // },
                                label: function(context) {
                                    // console.log(3, context);
                                    if (context.dataset.label === "Previous Efficiency") {
                                        const trend = props.granularity === "Day" ? "7 Day Trend" : props.granularity === "Week" ? "4 Week Trend" : "3 Month Trend";
                                        return `${trend}: ${Number(context.formattedValue).toFixed(1)}%`;
                                    }
                                    return `${context.dataset.label}: ${Number(context.formattedValue).toFixed(1)}%`;
                                },
                                // afterLabel: function(context) {
                                //     // console.log(4, context);
                                //     return `Previous Efficiency: ${Number(lineDataset[context.dataIndex]).toFixed(1)}%`;
                                // },
                            }
                        }
                    }
                }}
            />
        </div>
    )
}

export default TrendReportChartOEE;